import { useEffect } from "react";
import { TrackingClient } from "@sparefoot/tracking-client";

const usePageViewTracking = (pageType) => {
	useEffect(() => {
		if (typeof globalThis.window !== "undefined") {
			// Get the meta title from document
			const metaTitle = document.title || pageType;

			TrackingClient.trackPageView({
				page_name: metaTitle,
				page_type: pageType
			});
		}
	}, [pageType]);
};

export default usePageViewTracking;
